import React, { useState, useRef, useEffect } from 'react';
import propTypes from 'prop-types';

const Img = (props) => {
	const [imageWidth, setImageWidth] = useState(0);
	const image = useRef(null);
	const loadingStyles = {
		width: '100%',
		height: '100%',
		filter: 'blur(1rem)'
	};

	useEffect(() => {
		setImageWidth(image.current.clientWidth);
	}, []);

	return (
		<div className="ws-content-rows-img" ref={image}>
			<img
				style={imageWidth === 0 ? loadingStyles : {}}
				className={props.className}
				src={`${props.src}?impolicy=downsize_bkpt&w=${imageWidth}`}
				alt={props.alt}
			/>
		</div>
	);
};

Img.defaultProps = {
	className: ''
};

Img.propTypes = {
	className: propTypes.string,
	src: propTypes.string.isRequired,
	alt: propTypes.string.isRequired
};

export default Img;
